import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import OurStrength from '@/pages/OurStrength'
import Projects from '@/pages/Projects'
import ContactUs from '@/pages/ContactUs'
import HomingSeries from '@/pages/HomingSeries'


Vue.use(Router)

export default new Router({
  routes: [
    //网站首页
    { path: '/index', name: 'Index', component: Index },
    { path: '/ourStrength', name: 'OurStrength', component: OurStrength },
    { path: '/projects', name: 'Projects', component: Projects },
    { path: '/homingSeries', name: 'HomingSeries', component: HomingSeries },
    { path: '/contactUs', name: 'ContactUs', component: ContactUs },
    { path: '*', redirect: '/index' }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


